var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-meal-view-meal',_vm._g({attrs:{"state":_vm.state}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }